import { AccountAccess } from "../components/account-access.component"
import { DiscoverInvozio } from "../components/discover-invozio.component"
import { FAQSection } from "../components/faq-section.component"
import { FeatureInvoice } from "../components/fetaure-invoice.component"
import { Footer } from "../components/footer.component"
import Header from "../components/header.component"
import { HeroSection } from "../components/hero-section.component"
import { InvoicingForIndividuals } from "../components/invoicing-for-individuals.component"
import { PartnerLogo } from "../components/partner-logo.component"
import { SalaryCalculator } from "../components/salary-calculator.component"
import TestimonialsSection from "../components/testimonials-section.component"
import TrustpilotBadge from "../components/trustpilot-badge.component"
import '../scss/main.scss'

const LandingPage = () => {
  const sectionConfig = {
    FeatureInvoice,
    InvoicingForIndividuals,
    TestimonialsSection,
    SalaryCalculator,
    DiscoverInvozio,
    TrustpilotBadge,
    FAQSection
  };

  return (
    <>
      <Header  />
      <HeroSection  />
      <PartnerLogo />
      {Object.entries(sectionConfig).map(([key, Component]) => (
        <Component key={key} />
      ))}
      <div className="bg-footer">
        <AccountAccess />
        <Footer />
      </div>
    </>
  );
}
export default LandingPage;
